import { QueryClient } from '@tanstack/react-query'

/**
 * LOGISPRD-12506 — 콘솔 전용 QueryClient.
 *
 * `@/utils/queryClient` 를 재사용하지 않는 이유는 두 가지다.
 *  1. 그쪽 queryCache.onError 가 MAlert(어드민 모달)를 띄운다 — 콘솔 셸에는 그 DOM 마운트가 없다.
 *  2. 캐시 정책이 정반대다. 진단 도구는 같은 조건으로 다시 물었을 때 이전 응답을 주면 안 된다.
 *     "아까와 같은 값" 인지 "지금도 같은 값" 인지 구분이 안 되면 조치 판단이 틀어진다.
 *
 * 그래서 staleTime/gcTime 을 0 으로 두고, 조회는 사용자가 실행할 때만 돈다(enabled:false + refetch).
 * 선례: st06 재고현황(SLS, LOGISPRD-12147).
 */
export const consoleQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      enabled: false,
      staleTime: 0,
      gcTime: 0,
      retry: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  },
})
